export const ResponseUI = {
  button: "md:h-10 h-9",
  text: "xs:text-xs sm:text-sm md:text-md lg:text-lg",
};

export default ResponseUI;
